import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';

interface HelpSection {
  title: string;
  icon: string;
  content: string;
  expanded?: boolean;
}

interface FAQ {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-help-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatExpansionModule,
    MatDividerModule,
    MatListModule
  ],
  templateUrl: './help-dialog.component.html',
  styleUrl: './help-dialog.component.scss'
})
export class HelpDialogComponent {
  helpSections: HelpSection[] = [
    {
      title: 'Como navegar no sistema',
      icon: 'navigation',
      content: 'Use o menu lateral para acessar diferentes páginas. O dashboard mostra informações importantes e acesso rápido às funcionalidades principais.',
      expanded: true
    },
    {
      title: 'Acesso aos serviços Unicamp',
      icon: 'wifi',
      content: 'Clique em "Wi-Fi + Apps Unicamp" no dashboard para ativar seu acesso aos serviços digitais da universidade, incluindo Office 365 e rede Wi-Fi.'
    },
    {
      title: 'Documentos e certificados',
      icon: 'description',
      content: 'Acesse a seção de documentos para baixar certificados, declarações e outros documentos acadêmicos importantes.'
    },
    {
      title: 'Pagamentos e boletos',
      icon: 'payment',
      content: 'Na seção de pagamentos você pode visualizar boletos pendentes, histórico de pagamentos e informações financeiras.'
    }
  ];

  faqs: FAQ[] = [
    {
      question: 'Como alterar minha senha?',
      answer: 'Acesse "Meus Dados" no menu lateral e clique em "Alterar Senha". Você precisará informar sua senha atual e definir uma nova.'
    },
    {
      question: 'Não consigo acessar o Wi-Fi da Unicamp',
      answer: 'Verifique se você ativou os serviços digitais na página "Wi-Fi + Apps Unicamp". Use seu RA@unicamp.br e senha para conectar.'
    },
    {
      question: 'Como baixar meu certificado?',
      answer: 'Vá para a seção "Certificados" e selecione o curso desejado. Clique em "Baixar" para obter o arquivo PDF.'
    },
    {
      question: 'Preciso de ajuda com o Office 365',
      answer: 'Após ativar os serviços, acesse office.com com seu email institucional. Em caso de problemas, entre em contato com o suporte técnico.'
    }
  ];

  constructor(private dialogRef: MatDialogRef<HelpDialogComponent>) {}

  closeDialog() {
    this.dialogRef.close();
  }

  toggleSection(section: HelpSection) {
    section.expanded = !section.expanded;
  }
}
